"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
//PRE_QUALIFICATION_ACCEPT_DECLINED_URL
function PreQualificationAcceptDeclinedPage() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("h1", { className: "first-title", children: "Credit Application" }), (0, jsx_runtime_1.jsx)("p", { className: "first-subtitle", children: "Thank you for your interest." }), (0, jsx_runtime_1.jsx)("p", { children: "We were unable to prequalify you." })] }) }));
}
exports.default = PreQualificationAcceptDeclinedPage;
